import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M53.3333333,628.96 C735.786667,628.96 1291.09333,1184.16 1291.09333,1866.72 L1291.09333,1866.72 L1291.09333,1920.05333 L882.24,1920.05333 L882.24,1866.72 C882.24,1409.65333 510.4,1037.81333 53.3333333,1037.81333 L53.3333333,1037.81333 L0,1037.81333 L0,628.96 Z M53.3333333,0 C1082.56,0 1920,837.44 1920,1866.66667 L1920,1866.66667 L1920,1920 L1511.14667,1920 L1511.14667,1866.66667 C1511.14667,1062.82667 857.173333,408.853333 53.3333333,408.853333 L53.3333333,408.853333 L0,408.853333 L0,0 Z M267.189333,1386.66667 C413.962667,1386.66667 533.322667,1506.02667 533.322667,1652.8 C533.322667,1799.57333 413.962667,1919.04 267.189333,1919.04 C120.416,1919.04 0.949333333,1799.57333 0.949333333,1652.8 C0.949333333,1506.02667 120.416,1386.66667 267.189333,1386.66667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRssSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconRssSolid, _Component);

  var _super = _createSuper(IconRssSolid);

  function IconRssSolid() {
    _classCallCheck(this, IconRssSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconRssSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRss",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRssSolid.displayName = "IconRssSolid";
  return IconRssSolid;
}(Component);

IconRssSolid.glyphName = 'rss';
IconRssSolid.variant = 'Solid';
IconRssSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRssSolid;
export { IconRssSolid };